// extracted by mini-css-extract-plugin
module.exports = {"FAQ_section":"FAQs_FAQ_section__3mfbA","addLink":"FAQs_addLink__2AlMY","conversationText":"FAQs_conversationText__2Viub","inputTextare":"FAQs_inputTextare__1BexR"};